import { Get } from 'src/axios';
import { TInformationCompany } from 'src/types/aboutCompany';

export const getCompanyInfo = () =>
  Get<TInformationCompany>('/staticpages/static/');
